var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "preloader-wrapper active",
      style: `width: ${_vm.diameter}px; height: ${_vm.diameter}px;`,
    },
    [
      _c("div", {
        staticClass: "absolute border border-gray-500 rounded-full m-px",
        style: `width: ${_vm.diameter - 2}px; height: ${_vm.diameter - 2}px;`,
      }),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner-layer border-primary-600" }, [
      _c("div", { staticClass: "circle-clipper left" }, [
        _c("div", { staticClass: "circle" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gap-patch" }, [
        _c("div", { staticClass: "circle" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "circle-clipper right" }, [
        _c("div", { staticClass: "circle" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }